/** User-facing MLS activation timeline after paid checkout. */
export const MLS_ACTIVATION_TIMELINE =
  "MLS are activated in up to 3 working days after payment."

export const MLS_PURCHASE_THANK_YOU = "Thank you for your purchase."

export function mlsPendingActivationMessage(assignAfter) {
  const assignAfterDate = assignAfter ? new Date(assignAfter) : null
  const pastDue =
    assignAfterDate &&
    !Number.isNaN(assignAfterDate.getTime()) &&
    assignAfterDate.getTime() <= Date.now()

  if (pastDue) {
    return "We're still completing your MLS setup. If your MLS aren't active yet, contact support."
  }
  return MLS_ACTIVATION_TIMELINE
}

export function mlsPurchasePaidCustomerMessage({ names }) {
  const mlsLabel = names ? ` for ${names}` : ""
  return `${MLS_PURCHASE_THANK_YOU} Payment received${mlsLabel}. ${MLS_ACTIVATION_TIMELINE}`
}
